import PropTypes from 'prop-types';

import useRequest from 'core/hooks/useRequest';
import { topicsQuery } from 'core/queries/topics';

import themePropTypes from 'core/utils/prop-types/theme';
import modelPropTypes, { topicAttributes } from 'core/utils/prop-types/model';

import Loader from 'core/components/Loader';
import withTheme from 'core/hocs/withTheme';

import Content from '../Content';
import Header from '../Header';
import { VOID_QUERY } from 'core/site/constants';


/**
 * Карточки верстаем только на сайтах.
 * В LB они не имеют смысла.
 */
const FallbackCard = () => null;

/**
 * @author Aleksey Dibrivniy <a.dibrivniy@rambler-co.ru>
 */
function ReadMore(props) {
  const {
    content,
    title,
    theme,
    ids,
    include,
    ...cardsProps
  } = props;

  const queryParams = content
    ? VOID_QUERY
    : topicsQuery({ ids, include });
  const { data = content, isLoading } = useRequest(queryParams);

  if (isLoading) return <Loader />;

  const hasData = data && data.length > 0;

  if (!hasData) return null;

  const {
    controls: {
      vikontReadMore: {
        block: {
          background,
          padding,
          margin,
          borderRadius,
          borderTop,
          borderBottom,
          borderLeft,
          borderRight,
        },
      },
    },
  } = theme;

  return (
    <div className='readMore'>
      <style jsx>{`
        .readMore
          background ${background}
          padding ${padding}
          margin ${margin}
          border-top ${borderTop}
          border-bottom ${borderBottom}
          border-left ${borderLeft}
          border-right ${borderRight}
          border-radius ${(borderRadius ? borderRadius + 'px' : 0)}
      `}</style>
      {title && <Header>{title}</Header>}
      <Content
        content={data}
        {...cardsProps}
      />
    </div>
  );
}

ReadMore.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string),
  include: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  theme: themePropTypes(`{
    controls: {
      vikontReadMore: {
        block: {
          background,
          padding,
          margin,
          borderRadius,
          borderTop,
          borderBottom,
          borderLeft,
          borderRight,
        },
      }
    },
  }`),
  /**
   * Заголовок блока
   */
  title: PropTypes.string,
  /**
   * 1 топик
   */
  singleCard: PropTypes.func,
  /**
   * 2 топика
   */
  feedCard: PropTypes.func,
  /**
   * 3 и более топиков
   */
  drumCard: PropTypes.func,

  content: PropTypes.arrayOf(modelPropTypes(topicAttributes)),
};

ReadMore.defaultProps = {
  singleCard: FallbackCard,
  feedCard: FallbackCard,
  drumCard: FallbackCard,
};

export default withTheme(ReadMore);
